<script type="text/javascript">
// 定义一些公共的属性和方法
//const httpUrl = "http://localhost:8080/";
const httpUrl = "/";




// ++++++++++++++公共的方法++++++++++

//字符串转base64
function encode(str) {
  // 对字符串进行编码
  var encode = encodeURI(str);
  // 对编码的字符串转化base64
  var base64 = btoa(encode);
  return base64;
}

// base64转字符串
function decode(base64) {
  // 对base64转编码
  if (isBase64(base64)) {
    var decode = atob(base64);
    // 编码转字符串
    var str = decodeURI(decode);
    return str;
  } else {
    return base64;
  }
}

function isBase64(str) {
  if (str === "" || str.trim() === "") {
    return false;
  }
  try {
    return btoa(atob(str)) == str;
  } catch (err) {
    return false;
  }
}

// 暴露出这些属性和方法
export default {
  httpUrl,
  encode,
  decode,
};
</script>